import { map, snakeCase } from 'lodash'
import { v4 as uuid } from 'uuid'

export const transformLocationSettings = (
  locationSettings,
  venueUuid,
  revenueCenterUuid
) => {
  return (
    map(locationSettings, (setting, index) => {
      return {
        name: snakeCase(index),
        value: setting,
        venue_uuid: venueUuid,
        revenue_center_uuid: revenueCenterUuid,
        external_ref_id: uuid(),
      }
    }) ?? []
  )
}
